export default __webpack_public_path__ + "static/media/feature-multilang.959d41c2.webp";